/**
 * Console Log Target
 * 
 * Outputs logs to the browser console with appropriate console methods.
 */

import type { LogEntry, LogTarget } from '../types.js';
import { LogLevel } from '../types.js';

/**
 * Console log target
 */
export class ConsoleTarget implements LogTarget {
  write(entry: LogEntry): void {
    const { level, message, metadata, traceId, source } = entry;
    const prefix = source ? `[${source}]` : '';
    const tracePrefix = traceId ? `[Trace: ${traceId.substring(0, 8)}]` : '';
    const fullPrefix = `${prefix} ${tracePrefix}`.trim();

    const logData = metadata ? [message, metadata] : [message];

    switch (level) {
      case LogLevel.Debug:
        console.debug(fullPrefix ? `${fullPrefix} ${message}` : message, ...(metadata ? [metadata] : []));
        break;
      case LogLevel.Info:
        console.info(fullPrefix ? `${fullPrefix} ${message}` : message, ...(metadata ? [metadata] : []));
        break;
      case LogLevel.Warn:
        console.warn(fullPrefix ? `${fullPrefix} ${message}` : message, ...(metadata ? [metadata] : []));
        break;
      case LogLevel.Error:
        console.error(fullPrefix ? `${fullPrefix} ${message}` : message, ...(metadata ? [metadata] : []));
        break;
      default:
    }
  }
}

